module.exports = "<input type=\"text\" [ngModel]=\"internalDate\" (ngModelChange)=\"inputFieldChanged($event)\" class=\"form__input\" [placeholder]=\"placeholder?placeholder:''\">"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/date-time-picker/date-time-picker.html
// module id = s1+N
// module chunks = 12